var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompareWorkflowIcon = function SvgCompareWorkflowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 2.4a2.597 2.597 0 0 1 2.597 2.53A6.6 6.6 0 0 1 16.603 11q-.002.398-.05.783a2.596 2.596 0 0 1-2.597 4.496A6.57 6.57 0 0 1 10 17.6a6.57 6.57 0 0 1-3.957-1.318 2.597 2.597 0 0 1-2.599-4.497 6.6 6.6 0 0 1 3.958-6.853 2.6 2.6 0 0 1 2.598-2.53M7.66 6.13a5.4 5.4 0 0 0-3.046 5.28 2.596 2.596 0 0 1 2.339 4.047A5.38 5.38 0 0 0 10 16.4c1.13 0 2.178-.35 3.046-.945a2.596 2.596 0 0 1 2.338-4.047 5 5 0 0 0 .019-.408 5.4 5.4 0 0 0-3.065-4.87 2.6 2.6 0 0 1-2.338 1.47 2.6 2.6 0 0 1-2.34-1.47M6.015 13.3a1.4 1.4 0 1 0-2.427 1.4 1.4 1.4 0 0 0 2.427-1.4m9.885-.514a1.4 1.4 0 1 0-1.401 2.426 1.4 1.4 0 0 0 1.401-2.426M10.001 3.6a1.401 1.401 0 1 0 0 2.802A1.401 1.401 0 0 0 10 3.6",
    clipRule: "evenodd"
  })));
};
export default SvgCompareWorkflowIcon;